@if (configuration) {
<mat-toolbar class="bottom-navigation-bar" [class.fourColumnsGrid]="qrCodeScannerEnabled">
  <a
    [routerLink]="isLoggedIn ? ['/', 'newsfeed'] : ['/']"
    [routerLinkActive]="'bottom-navigation-bar__link--active'"
    [routerLinkActiveOptions]="{
      matrixParams: 'ignored',
      queryParams: 'ignored',
      paths: 'exact',
      fragment: 'ignored'
    }"
    class="bottom-navigation-bar__link">
    <mat-icon>home</mat-icon>
    <span class="bottom-navigation-bar__name" i18n="@@uiShell-mobileBottomBar-start">Start</span></a
  >
  <a
    [routerLink]="['/', 'fairs', configuration.activeFair]"
    [routerLinkActive]="'bottom-navigation-bar__link--active'"
    class="bottom-navigation-bar__link">
    <mat-icon>event</mat-icon>
    @if (configuration.fairs[configuration.activeFair]; as activeFair) {
    {{ activeFair.shortName ?? activeFair.name }}
    }</a
  >
  @if (qrCodeScannerEnabled) {
  <a
    [routerLink]="['/', 'scanner']"
    [routerLinkActive]="'bottom-navigation-bar__link--active'"
    class="bottom-navigation-bar__link">
    <mat-icon>qr_code_scanner</mat-icon>
    <span class="bottom-navigation-bar__name" i18n="@@uiShell-mobileBottomBar-scanner">Scanner</span></a
  >
  }
  <a
    [routerLink]="['/', 'tickets']"
    [routerLinkActive]="'bottom-navigation-bar__link--active'"
    class="bottom-navigation-bar__link">
    <mat-icon>confirmation_number</mat-icon>
    <span class="bottom-navigation-bar__name" i18n="@@uiShell-mobileBottomBar-tickets">Tickets</span>
  </a>
  <a
    [routerLink]="['/', 'profile', 'business-card']"
    [routerLinkActive]="'bottom-navigation-bar__link--active'"
    class="bottom-navigation-bar__link bottom-navigation-bar__link--business-card">
    <mat-icon svgIcon="business-card"></mat-icon>
    <span class="bottom-navigation-bar__name" i18n="@@uiShell-mobileBottomBar-businessCard">Visitenkarte</span></a
  >
</mat-toolbar>
}
